import {
  formatMonthAnyo,
  printDataInHTMLElements,
  resultsetWithFields,
} from 'vlcishared';

import { formatValue, ID_ENERGIA_CONSUMIDA } from './common-energia';

export function widgetConsumoTotalMes(data) {
  const dataWithFields = resultsetWithFields(data);

  const dataConfig = {
    [ID_ENERGIA_CONSUMIDA]: {
      value: {
        element: '#consumoTotal',
        format: formatValue,
      },
      calculationperiod: {
        element: '#consumoFecha',
        format: formatMonthAnyo,
      },
    },
  };

  printDataInHTMLElements(dataWithFields, dataConfig);
}
